import { useQuery } from '@tanstack/react-query';
import { APP_SECTION_LIST, PROFILE_REWARD__LIST } from 'src/constants/queryKeys';
import axiosInstance from '../utils/axios';

export const networkGetProfileRewardInfo = async (profileRewardId) => {
  const res = await axiosInstance.post(`ProfileApplicationReward/Info/${profileRewardId}`);
  return res;
};

export function useFetchProfileRewardInfo(profileRewardId) {
  return useQuery({
    queryKey: [PROFILE_REWARD__LIST, profileRewardId],
    queryFn: () => networkGetProfileRewardInfo(profileRewardId),
  });
}

export const networkGetProfileRewardList = async (pageIndex = 0, pageSize = 30, data) => {
  const res = await axiosInstance.post(`ProfileApplicationReward/List/${pageIndex}/${pageSize}`, data);
  return res;
};

export function useFetchProfileRewardList(pageIndex = 0, pageSize = 50, payload) {
  return useQuery({
    queryKey: [PROFILE_REWARD__LIST, payload, pageIndex],
    queryFn: () => networkGetProfileRewardList(pageIndex, pageSize, payload),
  });
}

export const networkCreateProfileReward = async (data) => {
  const res = await axiosInstance.post('ProfileApplicationReward/Insert', data);
  return res;
};

export const networkUpdateProfileReward = async (profileRewardId, data) => {
  const res = await axiosInstance.post(`ProfileApplicationReward/Update/${profileRewardId}`, data);
  return res;
};

export const networkRemoveProfileReward = async (profileRewardId) => {
  const res = await axiosInstance.post(`ProfileApplicationReward/Remove/${profileRewardId}`);
  return res;
};
